import {ReactElement} from 'react'

interface DopamineAssistantFullscreenIconProps {
  isFullscreen: boolean
}

// Two diagonal arrows: pointing out to enter full screen, pointing in to leave it.
const ENTER_FULLSCREEN_PATH = 'M14 10l6-6M15 4h5v5M10 14l-6 6M9 20H4v-5'
const EXIT_FULLSCREEN_PATH = 'M20 4l-6 6M14 5v5h5M4 20l6-6M10 19v-5H5'

export const DopamineAssistantFullscreenIcon = ({
  isFullscreen,
}: DopamineAssistantFullscreenIconProps): ReactElement => (
  <svg
    aria-hidden="true"
    fill="none"
    height="16"
    viewBox="0 0 24 24"
    width="16"
  >
    <path
      d={isFullscreen ? EXIT_FULLSCREEN_PATH : ENTER_FULLSCREEN_PATH}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
    />
  </svg>
)
